import React, { createContext, FC, useMemo } from 'react';
import { HeaderContextProps, initContext } from './HeaderContext.model';
import { useSearchedStatus, useSearchList, useSideBar } from './hooks';

const HeaderContext = createContext(initContext);

const HeaderContextWrapper: FC<HeaderContextProps> = ({ children }) => {
  const sideBarContext = useSideBar();

  const searchListContext = useSearchList();

  const searchedStatusContext = useSearchedStatus();

  const context = useMemo(
    () => ({
      ...sideBarContext,
      ...searchListContext,
      ...searchedStatusContext,
    }),
    [sideBarContext, searchListContext, searchedStatusContext],
  );

  return (
    <HeaderContext.Provider value={context}>{children}</HeaderContext.Provider>
  );
};

export { HeaderContextWrapper, HeaderContext };
